
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Rocket, Loader, CircleCheck } from 'lucide-react';

type SubmitButtonProps = {
  isSubmitting: boolean;
  submissionSuccess: boolean;
};

const SubmitButton = ({ isSubmitting, submissionSuccess }: SubmitButtonProps) => {
  // Animation variants for the success icon
  const successVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: { 
      scale: 1, 
      opacity: 1,
      transition: { 
        type: 'spring',
        stiffness: 300,
        damping: 15
      }
    }
  };

  return (
    <motion.div
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      className="relative"
    >
      {submissionSuccess && (
        <motion.div 
          className="absolute -right-12 top-1/2 transform -translate-y-1/2"
          variants={successVariants}
          initial="hidden"
          animate="visible"
        >
          <CircleCheck className="h-8 w-8 text-green-400" />
        </motion.div>
      )}
      
      <Button 
        type="submit" 
        variant="gradient"
        className="group relative overflow-hidden px-8 py-3 rounded-md transition-all duration-300 shadow-lg hover:shadow-xl text-base font-medium w-full sm:w-auto"
        disabled={isSubmitting}
        aria-label={isSubmitting ? "Submitting form..." : "Submit contact form"}
        style={{
          background: "linear-gradient(135deg, #FF6B6B 0%, #FF8585 50%, #FF9B9B 100%)"
        }}
      >
        <span className="relative z-10 flex items-center justify-center gap-2">
          {isSubmitting ? (
            <>
              <span>Sending</span>
              <Loader className="h-5 w-5 animate-spin" />
            </>
          ) : (
            <>
              Let's Start Building
              <Rocket className="h-5 w-5 transition-transform group-hover:rotate-12" />
            </>
          )}
        </span>
        <span className="absolute inset-0 bg-gradient-to-r from-[#FF6B6B] to-[#FF8585] z-0"></span>
        <span className="absolute inset-0 bg-gradient-to-r from-[#FF6B6B] via-[#FF8585] to-[#33C3F0] z-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
      </Button>
    </motion.div>
  );
};

export default SubmitButton;
